import { createFileRoute } from '@tanstack/react-router'

import { SuccessPage } from '@/pages/success'

export const Route = createFileRoute('/success')({
  component: RouteComponent,
})

export const SuccessRoute = Route

function RouteComponent() {
  return <SuccessPage />
}
